/* ===== Inner Dragon · UGC — מעקב ייחוס רכישות (As Seen On) · v1 =====
 * מודול עצמאי, בלי תלויות. עונה על השאלה: האם הלקוחה קנתה אחרי
 * שצפתה בסרטוני ה-UGC, או ישירות מתוך הסקשן (לחיצה על כרטיס /
 * הוספה לסל בתוך הנגן)?
 *
 * איך זה עובד:
 * 1. ids-ugc-videos.js קורא ל-window.IDSUgcTrack.record(type, data)
 *    בשלושה רגעים: 'view' (סרטון מתנגן בנגן), 'card_click' (לחיצה
 *    על כרטיס מוצר בנגן), 'atc' (הוספה לסל מתוך הנגן הצליחה).
 * 2. האירועים נשמרים ב-localStorage (עד 40 אירועים, 14 יום).
 * 3. sync() מעדכן את מאפייני העגלה (cart attributes) דרך
 *    /cart/update.js — Shopify מעביר אותם אוטומטית להזמנה
 *    (note_attributes), והם מוצגים בעמוד ההזמנה באדמין.
 * 4. עטיפת fetch/XHR גלובלית: אחרי כל הוספה לסל מוצלחת בכל מקום
 *    באתר (גם מעמוד מוצר רגיל) — sync() רץ, כך שגם רכישה "אחרי
 *    צפייה" נתפסת, לא רק רכישה מתוך הסקשן.
 *
 * המאפיינים שנכתבים על העגלה/הזמנה:
 *   ugc_source            — "רכישה מתוך הסקשן" אם היה atc/card_click,
 *                           אחרת "צפתה בסרטונים לפני הרכישה".
 *   ugc_videos            — עד 6 הצפיות האחרונות, למשל:
 *                           "aura-black 06.07 14:22 | venus-pink 06.07 14:25"
 *   ugc_last_interaction  — חותמת זמן ISO של האירוע האחרון.
 */
(function () {
  'use strict';

  var EVENTS_KEY = 'ids_ugc_events';   /* יומן האירועים */
  var SYNCED_KEY = 'ids_ugc_synced';   /* מה כבר נשלח לעגלה (למניעת בקשות מיותרות) */
  var VIEWED_KEY = 'ids_ugc_viewed';   /* sessionStorage — דדופ צפיות לכל סשן */
  var MAX_EVENTS = 40;                 /* תקרת אירועים ביומן */
  var MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000; /* אירועים בני 14+ יום נמחקים */

  /* fetch המקורי — נשמר לפני העטיפה, כדי שהבקשות שלנו לא יעברו דרכה */
  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  /* ───────── יומן האירועים ב-localStorage ───────── */

  function loadEvents() {
    try {
      var arr = JSON.parse(localStorage.getItem(EVENTS_KEY) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function saveEvents(list) {
    try { localStorage.setItem(EVENTS_KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* מנקה אירועים ישנים מ-14 יום ושומר על תקרת 40 אירועים */
  function prune(list) {
    var cutoff = Date.now() - MAX_AGE_MS;
    list = list.filter(function (e) {
      var t = Date.parse(e && e.t);
      return !isNaN(t) && t >= cutoff;
    });
    if (list.length > MAX_EVENTS) list = list.slice(list.length - MAX_EVENTS);
    return list;
  }

  /* ───────── דדופ צפיות: פעם אחת לכל סרטון בכל סשן ───────── */

  function alreadyViewed(id) {
    try {
      var s = sessionStorage.getItem(VIEWED_KEY) || '';
      return s.split('|').indexOf(id) !== -1;
    } catch (e) { return false; }
  }

  function markViewed(id) {
    try {
      var s = sessionStorage.getItem(VIEWED_KEY) || '';
      sessionStorage.setItem(VIEWED_KEY, s ? s + '|' + id : id);
    } catch (e) {}
  }

  /* ───────── רישום אירוע ─────────
     type: 'view' | 'card_click' | 'atc'
     data: { video: <מזהה סרטון/handle>, product: <handle מוצר> } */
  function record(type, data) {
    if (type !== 'view' && type !== 'card_click' && type !== 'atc') return;
    data = data || {};
    var video = String(data.video || data.product || '');
    var product = String(data.product || '');

    if (type === 'view') {
      var dedupeId = video || product;
      if (!dedupeId || alreadyViewed(dedupeId)) return; /* כבר נרשמה צפייה בסשן הזה */
      markViewed(dedupeId);
    }

    var list = prune(loadEvents());
    list.push({ t: new Date().toISOString(), type: type, video: video, product: product });
    saveEvents(list);

    /* אינטראקציה ישירה בסקשן — מסנכרנים מיד (keepalive שורד ניווט) */
    if (type === 'atc' || type === 'card_click') sync();
  }

  /* ───────── בניית ערכי המאפיינים ───────── */

  /* "06.07 14:22" — יום.חודש שעה:דקות */
  function fmt(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return p(d.getDate()) + '.' + p(d.getMonth() + 1) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
  }

  function buildAttributes(list) {
    var direct = false;
    var views = [];
    var lastT = '';
    list.forEach(function (e) {
      if (e.type === 'atc' || e.type === 'card_click') direct = true;
      if (e.type === 'view') views.push(e);
      if (!lastT || e.t > lastT) lastT = e.t;
    });
    var summary = views.slice(-6).map(function (e) {
      return (e.video || e.product || '?') + ' ' + fmt(e.t);
    }).join(' | ');
    return {
      'ugc_source': direct ? 'רכישה מתוך הסקשן' : 'צפתה בסרטונים לפני הרכישה',
      'ugc_videos': summary,
      'ugc_last_interaction': lastT
    };
  }

  /* ───────── סנכרון לעגלה ─────────
     שולח רק אם הערכים השתנו מאז השליחה האחרונה (SYNCED_KEY).
     /cart/update.js ממזג מפתחות attributes — לא דורס מאפיינים אחרים. */

  var syncBusy = false;

  function sync() {
    if (!origFetch || syncBusy) return;
    var list = prune(loadEvents());
    if (!list.length) return;

    var attrs = buildAttributes(list);
    var fingerprint = JSON.stringify(attrs);
    var lastSent = null;
    try { lastSent = localStorage.getItem(SYNCED_KEY); } catch (e) {}
    if (lastSent === fingerprint) return; /* אין שינוי — אין בקשה */

    syncBusy = true;
    origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true /* שורד גם ניווט מיידי לעמוד אחר */
    }).then(function (res) {
      syncBusy = false;
      if (res && res.ok) {
        try { localStorage.setItem(SYNCED_KEY, fingerprint); } catch (e) {}
      }
    }).catch(function () { syncBusy = false; });
  }

  function scheduleSync() {
    setTimeout(sync, 300); /* נותנים לעגלה להתעדכן לפני הסנכרון */
  }

  /* ───────── עטיפה גלובלית: כל הוספה לסל מוצלחת → sync ─────────
     תופס /cart/add ו-/cart/add.js מכל מקום באתר (fetch וגם XHR),
     כך שגם רכישה מעמוד מוצר רגיל אחרי צפייה נושאת את הייחוס. */

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  function isCartAdd(input) {
    var url = '';
    try {
      if (typeof input === 'string') url = input;
      else if (input && typeof input.url === 'string') url = input.url;
      else url = String(input || '');
    } catch (e) {}
    return ADD_RE.test(url.split('#')[0]);
  }

  if (origFetch) {
    window.fetch = function (input, init) {
      var p = origFetch(input, init);
      if (isCartAdd(input)) {
        p.then(function (res) { if (res && res.ok) scheduleSync(); }).catch(function () {});
      }
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__idsUgcCartAdd = isCartAdd(url);
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__idsUgcCartAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) scheduleSync();
        });
      }
      return xhrSend.apply(this, arguments);
    };
  }

  /* ───────── סנכרון בטעינת עמוד ─────────
     מכסה תרחישי רענון/ניווט. קליל: בודק את העגלה (/cart.js) רק אם
     יש אירועים וגם הסנכרון האחרון אינו עדכני. */

  function initialSync() {
    if (!origFetch) return;
    var list = prune(loadEvents());
    if (!list.length) return;
    var fingerprint = JSON.stringify(buildAttributes(list));
    var lastSent = null;
    try { lastSent = localStorage.getItem(SYNCED_KEY); } catch (e) {}
    if (lastSent === fingerprint) return; /* כבר מסונכרן — בלי בקשות */
    origFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.item_count > 0) sync(); /* מסנכרנים רק כשיש עגלה */
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }

  /* ───────── API ציבורי ───────── */
  window.IDSUgcTrack = { record: record, sync: sync };
})();
